import { useEffect, useState } from 'react';
import { CallbackRequestsAPI } from '../services/api';
import { CALLBACKS_CHANGED_EVENT } from '../pages/User/callbackExperience';

const PENDING_CALLBACKS_REFRESH_MS = 60 * 1000;

// Pending 回电请求 count for a nav badge: on load, every minute, when the tab
// regains focus, and right after the callback list changes. Stops on 401/403
// (e.g. a sub-account without access) so it never nags the server.
// Pass enabled=false to skip polling entirely (e.g. for team members).
export const usePendingCallbackCount = (enabled = true) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!enabled) { setCount(0); return undefined; }
    let live = true;
    let stopped = false;
    const refresh = () => {
      if (stopped || (typeof document !== 'undefined' && document.visibilityState === 'hidden')) return;
      Promise.resolve().then(() => CallbackRequestsAPI.count('pending'))
        .then((data) => { if (live) setCount(Math.max(0, Number(data?.count) || 0)); })
        .catch((error) => {
          const status = error?.response?.status;
          if (status === 401 || status === 403) stopped = true;
        });
    };
    refresh();
    const timer = setInterval(refresh, PENDING_CALLBACKS_REFRESH_MS);
    const onVisible = () => { if (document.visibilityState === 'visible') refresh(); };
    window.addEventListener('focus', refresh);
    window.addEventListener(CALLBACKS_CHANGED_EVENT, refresh);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      live = false;
      clearInterval(timer);
      window.removeEventListener('focus', refresh);
      window.removeEventListener(CALLBACKS_CHANGED_EVENT, refresh);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [enabled]);
  return count;
};

export default usePendingCallbackCount;
